// export const ROW_HOVER_BG = "rgb(108, 173, 223)"; //  f0f4fa

export const ROW_HOVER_BG = "rgb(150, 193, 231)"; // 6CABDD f0f4fa rgb(108, 171, 221)
export const BUTTON_WORD = "rgb(20, 20, 20)"; // 6CABDD f0f4fa rgb(108, 171, 221)
